let globalNoColorwayProductHandle

  window.addEventListener('DOMContentLoaded', () => {
    const scrollToTop = document.querySelector('.bmsm-scroll-to-top')
    scrollToTop?.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  })

  class BMSMModal extends HTMLElement {
    constructor() {
      super()

      this.querySelector('bmsm-modal-close').addEventListener('click', () => {
        this.close()
        document.body.classList.remove('popup-scroll');
      })

      this.addEventListener('click', (e) => {
        if (e.target.classList.contains('bmsm-modal')) {
          this.close()
          document.body.classList.remove('popup-scroll');
        }
      })
    }

    async fetchColorData(collectionHandle, productHandle, productId, isRefreshing) {
      this.open()
      let url

      if(collectionHandle) {
        url = `${Shopify.routes.root}collections/${collectionHandle}?view=modal`
      } else {
        url = `${Shopify.routes.root}products/${productHandle}?view=amsm-modal`
      }

      if (isRefreshing) this.classList.add('refreshing')

      // NEED DEFAULT CASE IF NO COLLECTION HANDLE IS PRESENT

      try {
        const res = await fetch(url)
        const htmlString = await res.text()
        let foundForm = false

        this.querySelector('bmsm-modal-inner').innerHTML = htmlString
        this.setAttribute('data-collection-handle', collectionHandle)

        const allForms = this.querySelectorAll('form[data-product-id]')
        allForms.forEach((form) => {
          if(form.dataset.productId === productId) {
            form.classList.add('in')
            this.setDefaultOptions(form)
            foundForm = true
          }
        })
        if(!foundForm) {
          // if for some reason the product ID can't be found in the fetched modals, add 'in' to first form as a fallback.
          // Couldn't figure out why this was happening, but this solution works for now.
           const defaultForm = this.querySelector('form[data-product-id]')
           if (defaultForm) {
            defaultForm.classList.add('in')
          } else {
            // In other cases no forms are return when fetching by collectionHandle
            // For these cases fetching by productHandle works
            this.fetchColorData(null, productHandle, productId, isRefreshing)
          }
        }
        this.populateSelectedProduct()
        this.populateSelectedOptions()
        this.loaded()
      } catch (error) {
        console.error(error)
      }
    }

    storeSelectedOptions() {
      const fieldsets = Array.from( this.querySelectorAll('form.in variant-radios fieldset') )
      const selectedOptions = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
      })
      this.setAttribute('data-selected-options', selectedOptions);
    }

    populateSelectedOptions() {
      if(this.getAttribute('data-selected-options') === null  || this.getAttribute('data-selected-options') === '') {
        return;
      }
      this.getAttribute('data-selected-options').split(',').forEach((option, index) => {
        const fieldset = this.querySelector('form.in').querySelector(`fieldset:nth-of-type(${index + 1})`)
        if(fieldset !== null) {
          const input = fieldset.querySelector(`input[value="${option}"]`);
          if(input !== null && !input.classList.contains('disabled')) {
            input.checked = true;
            const variantRadios = input.closest('variant-radios')
            if( variantRadios !== null ) {
              variantRadios.onVariantChange();
            }
          }
        }
      })
    }

    populateSelectedProduct() {
      const allForms = this.querySelectorAll('form[data-product-id]')
      if(this.getAttribute('data-product-id') !== null && this.getAttribute('data-product-id') !== '' ) {
        const productId = this.getAttribute('data-product-id')
        const currentForm = this.querySelector(`form.in`);
        const newForm = this.querySelector(`form[data-product-id="${productId}"]`);
        if(currentForm !== null && newForm !== null ) {
          currentForm.classList.remove('in')
          newForm.classList.add('in')
        }
      }
    }

    setDefaultOptions(form) {
      console.log( 'data-selected-options', this.getAttribute('data-selected-options') );
      if( form.querySelectorAll('fieldset') === null ) {
        return
      }
      let defaultOptions = []
      if( this.getAttribute('data-selected-options') !== null ) {
        // prioritize the previously selected option
        defaultOptions.push( this.getAttribute('data-selected-options') ) ;
      }
      switch( form.querySelectorAll('fieldset').length ) {
        case 1:
          defaultOptions.push('Large', 'X-Large', 'XX-Large', '32');
          break;
        case 2:
          defaultOptions.push('34,30L', '32,30L', '34,32L', '32,32L');
          break;
        default:
      }

      for( let i=0 ; i<defaultOptions.length ; i++ ) {
        const defaultOption = defaultOptions[i].split(',');
        let hasAllOptions = true;
        form.querySelectorAll('fieldset').forEach((ele, index)=>{
          // console.log(index, ele.querySelector(`input[value="${ defaultOption[index] }"]`))
          if( ele.querySelector(`input[value="${ defaultOption[index] }"]`) === null ) {
            hasAllOptions = false;
          }
        })
        if( hasAllOptions ) {
          this.setAttribute('data-selected-options', defaultOption);
          break;
        }
      }
    }

    open() {
      this.classList.add('active')
      this.classList.add('loading')
      document.body.classList.add('popup-scroll');
    }

    close() {
      this.classList.remove('active')
      this.removeAttribute('data-collection-handle')
      this.removeAttribute('data-product-id')
       document.body.classList.add('popup-scroll');

      const announcementBar = document.getElementById("announcement-bar-progress-section");
      if (announcementBar !== null) {
        const announcementBarParent = announcementBar.parentElement;
        announcementBarParent.style.zIndex = 'var(--section-announcement-bar-index)';
      }

      const microCart = document.getElementById("micro-cart__wrapper");
      if (microCart !== null) {
        const microCartParent = microCart.parentElement;
        microCartParent.style.zIndex = 99;
        microCartParent.style.position = 'sticky';
      }
    }

    loaded() {
      if (this.classList.contains('refreshing')) this.classList.remove('refreshing')
      this.classList.remove('loading')

      const announcementBar = document.getElementById("announcement-bar-progress-section");
      if (announcementBar !== null) {
        const announcementBarParent = announcementBar.parentElement;
        announcementBarParent.style.zIndex = 'var(--bmsm-modal-open-index)';
      }

      const microCart = document.getElementById("micro-cart__wrapper");
      if (microCart !== null) {
        const microCartParent = microCart.parentElement;
        microCartParent.style.zIndex = 'var(--bmsm-modal-open-index)';
        microCartParent.style.position = 'fixed';
      }
    }

    refresh(productId) {
      const collectionHandle = this.getAttribute('data-collection-handle');
      // true = isRefreshing
      this.fetchColorData(collectionHandle, globalNoColorwayProductHandle, productId, true);
    }
  }
  customElements.define('bmsm-modal', BMSMModal)

  class BMSMModalAddButton extends HTMLElement {
    constructor() {
      super()

      this.addEventListener('click', (evt) => {
        evt.preventDefault()
        this.addToCart()
      })
    }

    addToCart(){
        this.form = this.closest('form')
        let formData = new FormData(this.form);
        console.log(this.form.dataset.productId)
        
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }
        const productId = this.form.dataset.productId
        this.form.classList.add('adding')
      
        console.log('addToCart', formData)
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData
        })
          .then(async (response) => {
            this.form.classList.remove('adding')
      
            // Refresh modal to show updated pricing and discount
            document.querySelector('bmsm-modal').refresh(productId);
      
            if(response.ok) {
              const responseData = await response.json();
              console.log("response: ", responseData);
              
              try {
                const response2 = await fetch(`${Shopify.routes.root}?sections=pack-builder-micro-cart`);
                const htmlSection = await response2.json();
                console.log(htmlSection);
                this.reRenderAnnouncementBarAndMicroCartAndCartCount(htmlSection);
              } catch (error) {
                console.error("Error fetching updated sections:", error);
              }
            }
          })
          .catch((error) => {
            this.form.classList.remove('adding')
            console.error('Error:', error)
          })
      }

    reRenderAnnouncementBarAndMicroCartAndCartCount(html) {
      const extractCustomElementHTML = (sectionHTML, customTag) => {
        if (!sectionHTML) return null;
        const openingTag = sectionHTML.match(new RegExp('<' + customTag + '[^>]*>'));
        const closingTag = `</${customTag}>`
        
        if (openingTag)
          return openingTag + sectionHTML.split(openingTag)[1].split(closingTag)[0] + closingTag;
        return null;
      }
    
      const microCartParent = document.querySelector('#micro-cart__wrapper')?.parentElement;
      if (microCartParent && html['pack-builder-micro-cart']) {
        const updatedHTML = extractCustomElementHTML(html['pack-builder-micro-cart'], 'micro-cart');
        if (updatedHTML) {
          microCartParent.innerHTML = updatedHTML;
        }
      }
    
      const cartCountParent = document.querySelector('#cart-count-wrapper');
      if (cartCountParent && html['header']) {
        const updatedHTML = extractCustomElementHTML(html['header'], 'cart-count');
        if (updatedHTML) {
          cartCountParent.innerHTML = updatedHTML;
        }
      }
    }

    


  }
  customElements.define('bmsm-modal-add-button', BMSMModalAddButton)

  class BMSMModalColorToggle extends HTMLElement {
    constructor() {
      super()

      this.addEventListener('click', (evt) => {
        evt.preventDefault()
        const productId = this.dataset.productId;
        const modal = this.closest('bmsm-modal');
        const currentForm = this.closest('form');
        const newForm = modal.querySelector(`form[data-product-id="${productId}"]`);
        if( newForm !== null ) {
          currentForm.classList.remove('in');
          newForm.classList.add('in');
          modal.setAttribute('data-product-id', productId);
          // modal.setAttribute('data-default-options', productId);
          modal.populateSelectedOptions();
        }
      })
    }
  }
  customElements.define('bmsm-modal-color-toggle', BMSMModalColorToggle)

  
  class VariantSelects extends HTMLElement {
    constructor() {
      super()
      this.addEventListener('change', this.onVariantChange)
    }

    onVariantChange() {
      this.updateOptions()
      this.updateMasterId()
      this.toggleAddButton(true, '', false)
      // this.updatePickupAvailability()
      // this.removeErrorMessage()
      this.updateVariantStatuses()
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true)
        this.setUnavailable()
      } else {
        //   this.updateMedia()
        //   this.updateURL()
        this.updateVariantInput()
        //   this.renderProductInfo()
        //   this.updateShareUrl()

        if( this.currentVariant.available ) {
          this.toggleAddButton(false, '', false)
          const modal = this.closest('bmsm-modal');
          modal.storeSelectedOptions();
        } else {
          this.toggleAddButton(true, 'Sold Out', false)
        }
      }

      let productsArray = [];

      const productVariantsScripts = document.querySelectorAll('script#product-variants-json');
      const productScripts = document.querySelectorAll('script#product-json');

      if (productVariantsScripts && productScripts) {
        productVariantsScripts.forEach(script => {
          const isCurrentProduct = script.textContent.includes(this.currentVariant.sku);

          const variantsData = JSON.parse(script.textContent).map(variant => {
            return {
              name: variant.name,
              id: variant.id,
              available: variant.available,
              size: variant.option1,
              length: variant?.option2
            };
          })

          const getProductId = () => {
            const aVariantId = variantsData[0].id; // can be any variant of this product
            
            let productID = null;
            productScripts.forEach(script => {
              const variantMatchesProduct = script.textContent.includes(aVariantId);
              if (variantMatchesProduct) productID = JSON.parse(script.textContent).id
            })
            return productID;
          }

          const setisUnavailable = () => {
            let isUnavailable = false;
            if (!isCurrentProduct) {
              variantsData.forEach(variant => {
                if (variant.available === false) {
                  if (variant?.length) {
                    if (this.currentVariant.option1 === variant.size && this.currentVariant.option2 === variant.length)
                      isUnavailable = true;
                  } else {
                    if (this.currentVariant.option1 === variant.size) isUnavailable = true;
                  }
                }
              })
            }
            return isUnavailable;
          }

          const productData = {
            id: getProductId(),
            isCurrentProduct,
            variantsData,
            isUnavailable: setisUnavailable(),
          }

          productsArray.push(productData);
        });

        const colorToggles = document.querySelectorAll('bmsm-modal-color-toggle');
        colorToggles.forEach(colorToggle => {
          const prodData = productsArray.find(prod => prod.id.toString() === colorToggle.dataset.productId);
          if (prodData && prodData.isUnavailable) {
            colorToggle.classList.add('unavailable')
          } else {
            colorToggle.classList.remove('unavailable')
          }
        })
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option
          })
          .includes(false)
      })
    }

    updateVariantInput() {
      const productForm = this.closest('form')
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      /*
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      */
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1,
      )
      const inputWrappers = [...this.querySelectorAll('.product-form__input')]
      inputWrappers.forEach((option, index) => {
        if (index === 0) return
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`])
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      })
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      //
    }

    updatePickupAvailability() {
      //
    }

    removeErrorMessage() {
      //
    }

    renderProductInfo() {
      //
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`)
      if (!productForm) return
      const addButton = productForm.querySelector('[name="add"]')
      const addButtonText = productForm.querySelector('[name="add"] > span')
      if (!addButton) return

      if (disable) {
        addButton.setAttribute('disabled', 'disabled')
        if (text) addButtonText.textContent = text
      } else {
        addButton.removeAttribute('disabled')
        addButtonText.textContent = 'Add to Cart'
      }

      if (!modifyClass) return
    }

    setUnavailable() {
      /*
      const button = document.getElementById(`product-form-${this.dataset.section}`)
      const addButton = button.querySelector('[name="add"]')
      const addButtonText = button.querySelector('[name="add"] > span')
      const price = document.getElementById(`price-${this.dataset.section}`)
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
      const sku = document.getElementById(`Sku-${this.dataset.section}`)
      const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`)
      const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)
      const volumeTable = document.getElementById(`Volume-${this.dataset.section}`)
      const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)

      if (!addButton) return
      addButtonText.textContent = window.variantStrings.unavailable
      if (price) price.classList.add('hidden')
      if (inventory) inventory.classList.add('hidden')
      if (sku) sku.classList.add('hidden')
      if (pricePerItem) pricePerItem.classList.add('hidden')
      if (volumeNote) volumeNote.classList.add('hidden')
      if (volumeTable) volumeTable.classList.add('hidden')
      if (qtyRules) qtyRules.classList.add('hidden')
      */
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
      return this.variantData
    }
  }
  customElements.define('variant-select', VariantSelects)

  class VariantRadios extends VariantSelects {
    constructor() {
      super()
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled')
        } else {
          input.classList.add('disabled')
        }
      })
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'))
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
      })
    }
  }
  customElements.define('variant-radios', VariantRadios)
  

  class BMSMProduct extends HTMLElement {
    constructor() {
      super()
      this.addEventListener('click', async () => {
        const bmsmModal = document.querySelector('bmsm-modal')
        if(bmsmModal !== null) {
          const productId = this.dataset.productId
          const colorCollectionHandle = this.dataset.colorwayCollectionHandle
          const productHandle = this.dataset.productHandle
          globalNoColorwayProductHandle = this.dataset.productHandle
          const colorData = await bmsmModal.fetchColorData(colorCollectionHandle, productHandle, productId)
        }
      })
    }
  }
  customElements.define('bmsm-product', BMSMProduct)

  class BMSMTabsToggle extends HTMLElement {
    constructor() {
      super()

      this.sectionId = "template--15746180612214__add_more_save_more_8gaUnc";
      this.section = document.querySelector(`#shopify-section-${this.sectionId}`);

      this.querySelectorAll('a').forEach((a) => {
        a.addEventListener('click', (evt) => {
          evt.preventDefault()
          console.log("Clicked....")
          const targetId = a.getAttribute('href').replace('#', '');
          const targetTitle = this.section.querySelector(`[id="${targetId}"]`);
          if( targetTitle === null ) {
            return;
          }
          const targetSection = targetTitle.closest('.bmsm-collection-products');
          this.querySelectorAll('a').forEach((ele) => {
            ele.classList.remove('active');
          });
          this.section.querySelectorAll('.bmsm-collection-products').forEach((ele) => {
            ele.classList.remove('in');
          });
          a.classList.add('active');
          targetSection.classList.add('in');
        })
      });
    }
  }
  customElements.define('bmsm-tabs-toggle', BMSMTabsToggle)


